export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.env.VITE_HISTOIRE !== 'true') {
    return
  }

  // Histoire renders stories without <NuxtLayout />; silence the dev-only layout warning.
  nuxtApp._isNuxtLayoutUsed = true
})
